import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationStart, Router} from '@angular/router';
import {Actions, ofActionDispatched} from '@ngxs/store';
import {SetPaymentStepAfripay} from '../shared/map.actions';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import {ThemePalette} from '@angular/material/core';
import {Session} from '../../interfaces/session-data';
import {TransactionService} from '../../services/transaction/transaction.service';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-afripay',
  templateUrl: './afripay.component.html',
  styleUrls: ['./afripay.component.scss']
})
export class AfripayComponent implements OnInit {

  // payment
  paymentMethod: string = "";
  paymentMethodBackground: string = "";
  paymentMethodImg: string = "";
  paymentMethodLogo: string = "";
  session: Session;

  // routes arr
  routes = ['/virtual/afripay/wallet', '/virtual/afripay/confirmation', '/virtual/afripay/processing', '/virtual/afripay/status'];

  // loader
  loading: boolean = true;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'determinate';
  value = 50;
  diameter = 75;

  // timeout + interval
  transactionInterval;
  transactionTimeout;

  timer = 1800;
  hidePgLogo = false;

  constructor(private router: Router, private route: ActivatedRoute, private actions$: Actions, private transactionService: TransactionService) {
    this.paymentMethod = 'wallet';
    sessionStorage.setItem('selected-payment', 'wallet');

    // this.paymentMethodLogo = `../../assets/icons/Payment_Cards/svg/logo_${this.paymentMethod}.svg`;
    this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}_step_one.png`;

    this.session = JSON.parse(sessionStorage.getItem('sessionData'));

    router.events
    .pipe(
      filter(
        (events) => {
          return (events instanceof NavigationStart);
        }
      )
    )
    .subscribe((events: NavigationStart) => {
      if (events.navigationTrigger === 'popstate') {
        this.router.navigate([this.session.virtualRoute])
          .then((data) => {
            this.loading = false;
          });
      }
    });

    this.actions$
    .pipe(ofActionDispatched(SetPaymentStepAfripay))
    .subscribe(({ payload }) => this.paymentMethodImg = `../../assets/icons/Payment_Cards/svg/image_${this.paymentMethod}_${payload.toLowerCase()}.png`);
  }

  clearIntervalAndDoAppropriateAction() {
    clearInterval(this.transactionInterval);
    this.router.navigate(['error']);
  }

  ngOnInit(): void {
    sessionStorage.setItem('TRANSACTION_CONFIRMED_PAYMENT_METHOD', this.paymentMethod);
    this.hidePgLogo = this.session?.sessionDisplayInformation?.hidePgLogo === 'true';
    if (this.router.routerState.snapshot.url.indexOf('afripay/') === -1) {


    } else {
      this.loading = false;
    }

    this.transactionInterval = setInterval(() => {
      this.timer -= 1;
      if (this.timer === 0)
        return this.clearIntervalAndDoAppropriateAction();
    }, 1000);

    //setTimeout(() => {
      this.loading = false;
      this.router.navigate(['wallet'], { relativeTo: this.route });
    //}, 2 * 1000);


  }

  goBack() {
    sessionStorage.setItem("goBack", "true");
    return this.router.navigate(['virtual']);
  }

}
